<template>
  <div class="edit-base-shelf-item">
    <div class="edit-shelfname-label">是否开启海报<i class="vip">VIP</i></div>
    <div class="poster-open">
      <el-select class="personal-item-select" size="mini" v-model="isPoster" @change="changePosterType">
        <el-option v-for="item in posterOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="posterStyle" v-if="isPoster === 1">
      <el-select class="personal-item-select" size="mini" v-model="selPoster" @change="changePosterStyle">
        <el-option v-for="item in posterStyleOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="customSec" v-if="selPoster === 1 && customTit">
      <span class="customTit">{{ customTit }}</span>
      <button @click="replaceCus">替换</button>
    </div>
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
    <CustomPos ref="customPos" :qrObj="qrObj" @getCusImg="getCusImg" @getCustomTit="getCustomTit"></CustomPos>
  </div>
</template>

<script>
import TipDialog from '@components/common/TipDialog.vue'
import CustomPos from '@components/poster/customPos'
import compareVipRight from '@components/common/compareVipRight.js'
export default {
  name: 'shelfLibPoster',
  data() {
    return {
      //   myType: this.type,
      posterOptions: [
        {
          value: 0,
          label: '否'
        },
        {
          value: 1,
          label: '是'
        }
      ],
      posterStyleOptions: [
        {
          value: 0,
          label: '默认风格'
        },
        {
          value: 1,
          label: '自定义'
        }
      ],
      cusImg: ''
    }
  },
  mixins: [compareVipRight],
  computed: {
    isMember() {
      return this.$store.state.common.vipInfo.isMember
    },
    albumId() {
      return window.sessionStorage.getItem('albumId')
    },
    libId() {
      return window.sessionStorage.getItem('libId')
    },
    isPoster: {
      get: function() {
        let data1 = this.$store.state.config.bookLibObj.isPoster
        let data2 = this.$store.state.config.bookShelfObj.isPoster
        if (this.type.getType == 'Lib') {
          return data1
        } else {
          return data2
        }
      },
      set: function(newValue) {
        if (this.type.getType == 'Lib') {
          this.$store.commit('config/UPDATE_BOOK' + this.type.setType + 'ISPOSTER', newValue)
        } else {
          this.$store.commit('config/UPDATE_BOOKSHELFISPOSTER', newValue)
        }
      }
    },
    selPoster: {
      get: function() {
        let data1 = this.$store.state.config.bookLibObj.selPoster
        let data2 = this.$store.state.config.bookShelfObj.selPoster
        if (this.type.getType == 'Lib') {
          return data1
        } else {
          return data2
        }
      },
      set: function(newValue) {
        this.$store.commit('config/UPDATE_BOOK' + this.type.setType + 'SELPOSTER', newValue)
      }
    },
    customTit: {
      get: function() {
        let data1 = this.$store.state.config.bookLibObj.customTit
        let data2 = this.$store.state.config.bookShelfObj.customTit
        if (this.type.getType == 'Lib') {
          return data1
        } else {
          return data2
        }
      },
      set: function(newValue) {
        this.$store.commit('config/UPDATE_BOOK' + this.type.setType + 'CUSTOMTIT', newValue)
      }
    },
    posterAlbum() {
      return this.$store.state.config.poster.album
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    }
  },
  methods: {
    async changePosterType(value) {
      if (value == 1) {
        if (!(await this.compareRight({ type: 'boole', key: 'poster' }))) {
          this.$refs.memberDialog.visible = true
          this.$store.commit('config/UPDATE_BOOK' + this.type.setType + 'ISPOSTER', 0)
        }
      }
    },
    async changePosterStyle(value) {
      if (await this.compareRight({ type: 'boole', key: 'poster' })) {
        if (value == 1) {
          this.$refs.customPos.dialogVisible = true
        }
      } else {
        this.$refs.memberDialog.visible = true
        this.selPoster = value === 1 ? 0 : 1
      }
    },
    async replaceCus() {
      if (!(await this.compareRight({ type: 'boole', key: 'poster' }))) {
        this.$refs.memberDialog.visible = true
      } else {
        this.$refs.customPos.dialogVisible = true
      }
    },
    getCustomTit(val) {
      this.customTit = val
    },
    getCusImg(val) {
      this.cusImg = val
      if (val.includes('attach/')) {
        this.$store.commit('config/UPDATE_BOOK' + this.type.setType + 'CUSIMG', this.cusImg)
      } else {
        const cusImg = 'poster.png'
        this.$store.commit('config/UPDATE_BOOK' + this.type.setType + 'CUSIMG', cusImg)
      }
    }
  },
  mounted() {
    this.$refs.customPos.isShowCover = this.posterAlbum.posterCover && this.posterAlbum.posterCover.length > 1 ? this.posterAlbum.posterCover[1] : ''
  },
  components: {
    TipDialog,
    CustomPos
  },
  props: {
    type: Object,
    qrObj: Object
  }
}
</script>

<style lang="scss" scoped>
.poster-open {
  margin-bottom: 20px;
}
.customSec {
  margin-top: 10px;
  height: 25px;
  width: 172px;
  display: flex;
  line-height: 25px;
  justify-content: space-between;
  button {
    width: 60px;
    cursor: pointer;
    background: #df5813;
    border: none;
    color: #fff;
  }
  .customTit {
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
  }
}
.edit-shelfname-label {
  display: -webkit-flex;
  display: flex;
  // justify-content: center;
  align-items: center;
  img {
    height: 24px;
    margin-left: 2px;
  }
  i {
    width: 30px;
    line-height: 20px;
    background: #df5813;
    text-align: center;
    color: #fff;
    font-size: 10px;
    margin-left: 5px;
    border-radius: 2px;
    font-style: normal;
    font-weight: bold;
  }
}
</style>
